import TestimonialBjkLogo from "~/assets/images/home/testimonial-bjk-logo.png";
import TestimonialBjk from "~/assets/images/home/testimonial-bjk.jpg";
import TestimonialMudo from "~/assets/images/home/testimonial-mudo.jpg";
import TestimonialThyLogo from "~/assets/images/home/testimonial-thy-logo.png";
import TestimonialThy from "~/assets/images/home/testimonial-thy.jpg";
import TestimonialMadparfumLogo from "~/assets/images/testimonial-madparfum-logo.png";
import TestimonialMadparfum from "~/assets/images/testimonial-madparfum.png";
import TestimonialManukaLogo from "~/assets/images/testimonial-manuka-logo.png";
import TestimonialManuka from "~/assets/images/testimonial-manuka.jpg";
import TestimonialMudoLogo from "~/assets/images/testimonial-mudo-logo.png";
import TestimonialSilvaLogo from "~/assets/images/testimonial-silva-logo.png";
import TestimonialSilva from "~/assets/images/testimonial-silva.png";
import TestimonialTatilsepetiLogo from "~/assets/images/testimonial-tatilsepeti-logo.png";
import TestimonialTatilsepeti from "~/assets/images/testimonial-tatilsepeti.jpg";

export const testimonials = [
  {
    id: 1,
    name: "Gürhan Uruğkök",
    avatar: TestimonialBjk,
    logo: TestimonialBjkLogo,
    roleKey: /** @i18n */ "testimonials.bjk.role",
    companyKey: /** @i18n */ "testimonials.bjk.company",
    quoteKey: /** @i18n */ "testimonials.bjk.quote",
  },
  {
    id: 2,
    name: "Huzeyfe Esen",
    avatar: TestimonialThy,
    logo: TestimonialThyLogo,
    roleKey: /** @i18n */ "testimonials.thy.role",
    companyKey: /** @i18n */ "testimonials.thy.company",
    quoteKey: /** @i18n */ "testimonials.thy.quote",
  },
  {
    id: 3,
    name: "Timur Erten",
    avatar: TestimonialMudo,
    logo: TestimonialMudoLogo,
    roleKey: /** @i18n */ "testimonials.mudo.role",
    companyKey: /** @i18n */ "testimonials.mudo.company",
    quoteKey: /** @i18n */ "testimonials.mudo.quote",
  },
  {
    id: 4,
    name: "Nurcan Keskin",
    avatar: TestimonialManuka,
    logo: TestimonialManukaLogo,
    roleKey: /** @i18n */ "testimonials.manuka.role",
    companyKey: /** @i18n */ "testimonials.manuka.company",
    quoteKey: /** @i18n */ "testimonials.manuka.quote",
  },
  {
    id: 5,
    name: "Borahan Filyos",
    avatar: TestimonialTatilsepeti,
    logo: TestimonialTatilsepetiLogo,
    roleKey: /** @i18n */ "testimonials.tatilsepeti.role",
    companyKey: /** @i18n */ "testimonials.tatilsepeti.company",
    quoteKey: /** @i18n */ "testimonials.tatilsepeti.quote",
  },
  {
    id: 6,
    name: "Uluğ Sungur",
    avatar: TestimonialMadparfum,
    logo: TestimonialMadparfumLogo,
    roleKey: /** @i18n */ "testimonials.madparfum.role",
    companyKey: /** @i18n */ "testimonials.madparfum.company",
    quoteKey: /** @i18n */ "testimonials.madparfum.quote",
  },
  {
    id: 7,
    name: "Muhammed Karapıçak",
    avatar: TestimonialSilva,
    logo: TestimonialSilvaLogo,
    roleKey: /** @i18n */ "testimonials.silva.role",
    companyKey: /** @i18n */ "testimonials.silva.company",
    quoteKey: /** @i18n */ "testimonials.silva.quote",
  },
];

export const getTestimonials = (translate) =>
  testimonials.map(({ roleKey, companyKey, quoteKey, ...testimonial }) => ({
    ...testimonial,
    role: translate(roleKey),
    company: translate(companyKey),
    quote: translate(quoteKey),
  }));
